import { RouteConfig } from "vue-router";

export const demoRouters: RouteConfig[] = [];

demoRouters.push({
  path: "/demo/about",
  name: "demoAbout",
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "demo" */ "@/views/About.vue"),
  meta: { name: "关于" },
});

demoRouters.push({
  path: "/demo/nav",
  name: "demoNavPage",
  component: () =>
    import(/* webpackChunkName: "demo" */ "@/views/demo/DemoNavPage.vue"),
  meta: { name: "示例导航" },
});

demoRouters.push({
  path: "/demo/doc",
  name: "demoDocPage",
  component: () =>
    import(/* webpackChunkName: "demo" */ "@/views/demo/DemoDocPage.vue"),
  meta: { name: "示例文档" },
});

demoRouters.push({
  path: "/demo/auth",
  name: "demoAuthPage",
  component: () =>
    import(/* webpackChunkName: "demo" */ "@/views/demo/DemoAuthPage.vue"),
  meta: { name: "匿名用户权限", auth: true },
});
demoRouters.push({
  path: "/demo/auth2",
  name: "demoAuthPage2",
  component: () =>
    import(/* webpackChunkName: "demo" */ "@/views/demo/DemoAuthPage.vue"),
  props: { user: true },
  meta: { name: "注册用户权限", auth: "user" },
});
// demoRouters.push({
//   path: '/demo/curd/list',
//   name: 'demoListPage',
//   component: () =>
//     import(/* webpackChunkName: "demolist" */ '@/views/demo/curd/DemoListPage.vue'),
//   meta: { name: '列表示例'  }
// });

demoRouters.push({
  path: "/demo/pull",
  name: "demoPullPage",
  component: () =>
    import(/* webpackChunkName: "demolist" */ "@/views/demo/DemoPullPage.vue"),
  meta: { name: "下拉示例" },
});

demoRouters.push({
  path: "/demo/jssdk/qrcode",
  name: "DemoQrcodePage",
  component: () =>
    import(
      /* webpackChunkName: "demojssdk" */ "@/views/demo/jssdk/DemoQrcodePage.vue"
    ),
  meta: { name: "扫描二维码" },
});

demoRouters.push({
  path: "/demo/jssdk/share",
  name: "DemoSharePage",
  component: () =>
    import(
      /* webpackChunkName: "demojssdk" */ "@/views/demo/jssdk/DemoSharePage.vue"
    ),
  meta: { name: "菜单分享朋友圈" },
});

// demoRouters.push({
//   path: '/demo/curd/validate',
//   name: 'demoValidatePage',
//   component: () =>
//     import(/* webpackChunkName: "demolist" */ '@/views/demo/curd/DemoValidatePage.vue'),
//   meta: { name: '列表示例'  }
// });
demoRouters.push({
  path: "/demo/curd/normal",
  name: "demoNormalPage",
  component: () =>
    import(
      /* webpackChunkName: "demolist" */ "@/views/demo/curd/DemoCurdPage.vue"
    ),
  meta: { name: "列表示例" },
});

demoRouters.push({
  path: "/demo/test3",
  name: "demoTestPage",
  component: () =>
    import(/* webpackChunkName: "demolist" */ "@/views/demo/DemoTestPage.vue"),
  meta: { name: "测试示例" },
});

demoRouters.push({
  path: "/demo/jssdk/daohang",
  name: "Daohang",
  component: () =>
    import(
      /* webpackChunkName: "demojssdk" */ "@/views/demo/jssdk/Daohang.vue"
    ),
  meta: { name: "开启导航" },
});
